import Link from 'next/link';
import { IComponentProps } from '@/interfaces/component.interface';
import { cn } from '@/lib/utils';

interface ComponentProps extends IComponentProps {
  text: any;
  component: 'header' | 'footer' | 'side';
  color: 'white' | 'black';
}

const MenuLinks = [
  {
    name: 'Studio',
    href: '/studio',
  },
  {
    name: 'Services',
    href: '/services',
  },
  {
    name: 'Projects',
    href: '/portfolio',
  },
  {
    name: 'Blog',
    href: '/blog',
  },
];

export default function NavLinks(props: ComponentProps) {
  const { text, component, color, ...restProps } = props;

  return (
    <nav className={`${component === 'header' && 'block'} sm:hidden z-10`}>
      <ul
        className={`${component === 'footer' && ' flex flex-col gap-2'} ${
          component === 'side' && ' flex flex-col mt-12'
        } ${component === 'header' && ' flex'}`}
      >
        {MenuLinks.map((item, index) => (
          <li
            key={index}
            className={cn(
              'flex items-center px-[30px] text-xl border-white leading-6 font-normal tracking-normal',
              { 'border-r-[0.75px]': index < MenuLinks.length - 1 },
              { 'border-[#101011]': color === 'black' }
            )}
          >
            <Link href={item.href} {...restProps}>
              <span>{text[item.name.toLowerCase()]}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
